import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../../providers'
import { validatePhoneNumber } from '../../../utils'
import { sendOtp } from '../../../services'

const initialLoginState = {
    status: 'idle',
    error: '',
}

const useLogin = () => {
    const [loginState, setLoginState] = useState(initialLoginState)
    const { status, error } = loginState
    const { phoneNumber } = useAuth()
    const navigate = useNavigate()

    const handlePhoneNumberSubmit = async () => {
        setLoginState((prevValues) => ({ ...prevValues, error: null }))

        const result = validatePhoneNumber(phoneNumber)
        if (result !== 'valid') {
            return setLoginState((prevValues) => ({
                ...prevValues,
                error: result,
            }))
        }

        try {
            if (result === 'valid') {
                const formattedPhoneNumber = `+91${phoneNumber}`
                setLoginState((prevValues) => ({
                    ...prevValues,
                    status: 'loading',
                }))

                const res = await sendOtp(formattedPhoneNumber)

                if (res?.data?.success) {
                    setLoginState((prevValues) => ({
                        ...prevValues,
                        status: 'success',
                    }))
                    return
                }
                setLoginState((prevValues) => ({
                    ...prevValues,
                    status: 'failed',
                    error: res?.data?.error || res?.error,
                }))
            }
        } catch (error) {
            setLoginState((prevValues) => ({
                ...prevValues,
                status: 'failed',
                error: error.message,
            }))
        }
    }

    useEffect(() => {
        if (status === 'success') {
            setLoginState((prevValues) => ({
                ...prevValues,
                status: 'idle',
            }))

            navigate('/otpverification', {
                state: {
                    from: '/login',
                },
            })
        }
    }, [status, navigate])

    return {
        handlePhoneNumberSubmit,
        status,
        error,
    }
}

export default useLogin
